import {
  DOWNLOAD_ATTENDEE_LIST,
  DOWNLOAD_ATTENDEE_LIST_FAILED,
  DOWNLOAD_ATTENDEE_LIST_SUCCESS,
  DOWNLOAD_AXISCARE_REPORTS,
  DOWNLOAD_AXISCARE_REPORTS_FAILED,
  DOWNLOAD_AXISCARE_REPORTS_SUCCESS,
  DOWNLOAD_BOOKING_PAYMENTS,
  DOWNLOAD_BOOKING_PAYMENTS_FAILED,
  DOWNLOAD_BOOKING_PAYMENTS_SUCCESS,
  DOWNLOAD_BOOKING_REPORTS,
  DOWNLOAD_BOOKING_REPORTS_FAILED,
  DOWNLOAD_BOOKING_REPORTS_SUCCESS,
  DOWNLOAD_BOOKING_USER_REPORTS,
  DOWNLOAD_BOOKING_USER_REPORTS_FAILED,
  DOWNLOAD_BOOKING_USER_REPORTS_SUCCESS,
  DOWNLOAD_CALENDAR_GROUP_REPORTS,
  DOWNLOAD_CALENDAR_GROUP_REPORTS_FAILED,
  DOWNLOAD_CALENDAR_GROUP_REPORTS_SUCCESS,
  DOWNLOAD_COMPLETED,
  DOWNLOAD_DEEPLINK_CODES,
  DOWNLOAD_DEEPLINK_CODES_FAILED,
  DOWNLOAD_DEEPLINK_CODES_SUCCESS,
  DOWNLOAD_FORM_PAYMENTS,
  DOWNLOAD_FORM_PAYMENTS_FAILED,
  DOWNLOAD_FORM_PAYMENTS_SUCCESS,
  DOWNLOAD_QUESTIONNAIRE_SCORES,
  DOWNLOAD_QUESTIONNAIRE_SCORES_FAILED,
  DOWNLOAD_QUESTIONNAIRE_SCORES_SUCCESS,
  DOWNLOAD_REFER_FRIEND_REPORT,
  DOWNLOAD_REFER_FRIEND_REPORT_FAILED,
  DOWNLOAD_REFER_FRIEND_REPORT_SUCCESS,
  DOWNLOAD_RESPONSES_REPORT,
  DOWNLOAD_RESPONSES_REPORT_FAILED,
  DOWNLOAD_RESPONSES_REPORT_SUCCESS,
  DOWNLOAD_SUB_CALENDAR_REPORTS,
  DOWNLOAD_SUB_CALENDAR_REPORTS_FAILED,
  DOWNLOAD_SUB_CALENDAR_REPORTS_SUCCESS,
  DOWNLOAD_USERS_LIST,
  DOWNLOAD_USERS_LIST_FAILED,
  DOWNLOAD_USERS_LIST_SUCCESS,
  DOWNLOAD_VIEWS_BY_USER,
  DOWNLOAD_VIEWS_BY_USER_FAILED,
  DOWNLOAD_VIEWS_BY_USER_SUCCESS,
  GET_DOWNLOADS,
  GET_DOWNLOADS_FAILED,
  GET_DOWNLOADS_SUCCESS,
  HIDE_DOWNLOAD_COMPLETED_MODAL,
  OPEN_DOWNLOAD_COMPLETED_MODAL,
} from "./actionTypes"

export const getDownloads = params => ({
  type: GET_DOWNLOADS,
  payload: params,
})

export const getDownloadsSuccess = response => ({
  type: GET_DOWNLOADS_SUCCESS,
  payload: response,
})

export const getDownloadsFailed = error => ({
  type: GET_DOWNLOADS_FAILED,
  payload: error,
})

export const openDownloadCompletedModal = () => ({
  type: OPEN_DOWNLOAD_COMPLETED_MODAL,
  payload: {},
})

export const hideDownloadCompletedModal = () => ({
  type: HIDE_DOWNLOAD_COMPLETED_MODAL,
  payload: {},
})

export const downloadCompleted = response => ({
  type: DOWNLOAD_COMPLETED,
  payload: response,
})

export const downloadResponsesReport = params => ({
  type: DOWNLOAD_RESPONSES_REPORT,
  payload: params,
})

export const downloadResponsesReportSuccess = response => ({
  type: DOWNLOAD_RESPONSES_REPORT_SUCCESS,
  payload: response,
})

export const downloadResponsesReportFailed = error => ({
  type: DOWNLOAD_RESPONSES_REPORT_FAILED,
  payload: error,
})

export const downloadQuestionnaireScores = params => ({
  type: DOWNLOAD_QUESTIONNAIRE_SCORES,
  payload: params,
})

export const downloadQuestionnaireScoresSuccess = response => ({
  type: DOWNLOAD_QUESTIONNAIRE_SCORES_SUCCESS,
  payload: response,
})

export const downloadQuestionnaireScoresFailed = error => ({
  type: DOWNLOAD_QUESTIONNAIRE_SCORES_FAILED,
  payload: error,
})

export const downloadBookingPayments = params => ({
  type: DOWNLOAD_BOOKING_PAYMENTS,
  payload: params,
})

export const downloadBookingPaymentsSuccess = response => ({
  type: DOWNLOAD_BOOKING_PAYMENTS_SUCCESS,
  payload: response,
})

export const downloadBookingPaymentsFailed = error => ({
  type: DOWNLOAD_BOOKING_PAYMENTS_FAILED,
  payload: error,
})

export const downloadFormPayments = params => ({
  type: DOWNLOAD_FORM_PAYMENTS,
  payload: params,
})

export const downloadFormPaymentsSuccess = response => ({
  type: DOWNLOAD_FORM_PAYMENTS_SUCCESS,
  payload: response,
})

export const downloadFormPaymentsFailed = error => ({
  type: DOWNLOAD_FORM_PAYMENTS_FAILED,
  payload: error,
})

export const downloadViewsByUser = params => ({
  type: DOWNLOAD_VIEWS_BY_USER,
  payload: params,
})

export const downloadViewsByUserSuccess = response => ({
  type: DOWNLOAD_VIEWS_BY_USER_SUCCESS,
  payload: response,
})

export const downloadViewsByUserFailed = error => ({
  type: DOWNLOAD_VIEWS_BY_USER_FAILED,
  payload: error,
})

export const downloadReferFriendReport = params => ({
  type: DOWNLOAD_REFER_FRIEND_REPORT,
  payload: params,
})

export const downloadReferFriendReportSuccess = response => ({
  type: DOWNLOAD_REFER_FRIEND_REPORT_SUCCESS,
  payload: response,
})

export const downloadReferFriendReportFailed = error => ({
  type: DOWNLOAD_REFER_FRIEND_REPORT_FAILED,
  payload: error,
})

export const downloadAttendeeList = params => ({
  type: DOWNLOAD_ATTENDEE_LIST,
  payload: params,
})

export const downloadAttendeeListSuccess = response => ({
  type: DOWNLOAD_ATTENDEE_LIST_SUCCESS,
  payload: response,
})

export const downloadAttendeeListFailed = error => ({
  type: DOWNLOAD_ATTENDEE_LIST_FAILED,
  payload: error,
})

export const downloadCalendarGroupReports = params => ({
  type: DOWNLOAD_CALENDAR_GROUP_REPORTS,
  payload: params,
})

export const downloadCalendarGroupReportsSuccess = response => ({
  type: DOWNLOAD_CALENDAR_GROUP_REPORTS_SUCCESS,
  payload: response,
})

export const downloadCalendarGroupReportsFailed = error => ({
  type: DOWNLOAD_CALENDAR_GROUP_REPORTS_FAILED,
  payload: error,
})

export const downloadSubCalendarReports = params => ({
  type: DOWNLOAD_SUB_CALENDAR_REPORTS,
  payload: params,
})

export const downloadSubCalendarReportsSuccess = response => ({
  type: DOWNLOAD_SUB_CALENDAR_REPORTS_SUCCESS,
  payload: response,
})

export const downloadSubCalendarReportsFailed = error => ({
  type: DOWNLOAD_SUB_CALENDAR_REPORTS_FAILED,
  payload: error,
})

export const downloadBookingUserReports = params => ({
  type: DOWNLOAD_BOOKING_USER_REPORTS,
  payload: params,
})

export const downloadBookingUserReportsSuccess = response => ({
  type: DOWNLOAD_BOOKING_USER_REPORTS_SUCCESS,
  payload: response,
})

export const downloadBookingUserReportsFailed = error => ({
  type: DOWNLOAD_BOOKING_USER_REPORTS_FAILED,
  payload: error,
})

export const downloadBookingReports = params => ({
  type: DOWNLOAD_BOOKING_REPORTS,
  payload: params,
})

export const downloadBookingReportsSuccess = response => ({
  type: DOWNLOAD_BOOKING_REPORTS_SUCCESS,
  payload: response,
})

export const downloadBookingReportsFailed = error => ({
  type: DOWNLOAD_BOOKING_REPORTS_FAILED,
  payload: error,
})

export const downloadUsersList = params => ({
  type: DOWNLOAD_USERS_LIST,
  payload: params,
})

export const downloadUsersListSuccess = response => ({
  type: DOWNLOAD_USERS_LIST_SUCCESS,
  payload: response,
})

export const downloadUsersListFailed = error => ({
  type: DOWNLOAD_USERS_LIST_FAILED,
  payload: error,
})

export const downloadDeeplinkCodes = params => ({
  type: DOWNLOAD_DEEPLINK_CODES,
  payload: params,
})

export const downloadDeeplinkCodesSuccess = response => ({
  type: DOWNLOAD_DEEPLINK_CODES_SUCCESS,
  payload: response,
})

export const downloadDeeplinkCodesFailed = error => ({
  type: DOWNLOAD_DEEPLINK_CODES_FAILED,
  payload: error,
})

export const downloadAxisCareReports = params => ({
  type: DOWNLOAD_AXISCARE_REPORTS,
  payload: params,
})

export const downloadAxisCareReportsSuccess = response => ({
  type: DOWNLOAD_AXISCARE_REPORTS_SUCCESS,
  payload: response,
})

export const downloadAxisCareReportsFailed = error => ({
  type: DOWNLOAD_AXISCARE_REPORTS_FAILED,
  payload: error,
})
